import React from 'react'
import {BsInstagram, BsTiktok} from 'react-icons/bs'

const SocialMedia = () => {
    return (
        <div className='app__social'>
            <div className='app__social-logo'>
                <a href='https://instagram.com/al_communitymanager?igshid=OGQ5ZDc2ODk2ZA==' target='_blank' rel="noreferrer">
                    <BsInstagram style={{width: '20px',height: '20px'}}/>
                </a>
            </div>
            <div className='app__social-logo'>
                <a href='https://www.tiktok.com/@al_communitymanager' target='_blank' rel="noreferrer">
                    <BsTiktok style={{width: '20px',height: '20px'}}/>
                </a>
            </div>
        </div>
    )
}

export default SocialMedia